import { apiClient } from '@src/config/api';
import { CheckProposalResponse, Proposal } from '@src/shared/models';

export const ProposalApi = {
  getProposal: (proposalId: string) =>
    apiClient.get<Proposal>(`/travel/proposal/${proposalId}`),

  checkProposal: (proposalId: string) =>
    apiClient.get<CheckProposalResponse>(
      `/travel/proposal/${proposalId}/check`
    ),

  retryCheckProposal: (proposalId: string) =>
    apiClient.post<CheckProposalResponse>(
      `/travel/proposal/${proposalId}/retry`
    ),
} as const;
